import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 120000, withCredentials: true });

export const fmtNum = (n, digits = 2) => {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  const num = Number(n);
  return num.toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};

export const fmtMoney = (n, currency = "£") => {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return `${currency}${Number(n).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const fmtInt = (n) => {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return Math.round(Number(n)).toLocaleString();
};

export const networkLabel = (n) => {
  if (n === "meta") return "Meta";
  if (n === "google") return "Google";
  return n || "—";
};
